import React, { useContext, useEffect, useState } from "react";
import { Card, Label, ModalBody, Badge } from "reactstrap";
import {
    Button,
    Block,
    BlockBetween,
    BlockDes,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Icon,
    Col,
    Row,
    OverlineTitle,
    Sidebar,
    UserAvatar,
} from "../../../components/Component";
import { useHistory } from "react-router";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { urlTenantID, currentTime, findUpper, formDataUsername, monthNames, timeStamp, todaysDate } from "../../../utils/Utils";
import { UserContext } from "../user-manage/UserContext";
import { notes } from "../user-manage/UserData";
import { Link } from "react-router-dom";
import { useLocation } from 'react-router-dom'
import TenantTab from "./TenantTab";
import TenantHeading from "./TenantHeading";
import Api from "../../../Api";
import Swal from "sweetalert2";
import { MenuItem, OutlinedInput, Select } from "@mui/material";
import { cloneDeep } from "lodash";
import { logDOM } from "@testing-library/react";

const Settings = ({ match }) => {
    const { contextData } = useContext(UserContext);
    const [data] = contextData;
    const location = useLocation()
    const [sideBar, setSidebar] = useState(false);
    const [user, setUser] = useState();
    const [noteData, setNoteData] = useState(notes);
    const [addNoteModal, setAddNoteModal] = useState(false);
    const [addNoteText, setAddNoteText] = useState("");
    const history = useHistory();

    const [val, setVal] = useState({
        CUSTOMER_PREFIX: "",
        PROVIDER_PREFIX: "",
        MATTER_PREFIX: "",
        APPOINTMENT_INTER: "",
        ACCOUNT_LOCKSTATE: [],
        NO_OF_PROVIDER: "",
        NOOF_ENCOUNTER_PERMONTH: "",
        NOOF_ENCOUNTER_PERYEAR: "",
        NOOF_MINUTE_PERMONTH: "",
        NOOF_MINUTE_PERYEAR: "",
        ISPROVIDER_EMAIL_CONFIGURATION: true,
        APPOINTMENT_EMAIL_CONFIGURATION: true,
        ISCUSTOMER_EMAIL_CONFIGURATION: true,
    });
    const [prefer, setPrefer] = useState({
        CUSTOMER_PREFIX: "",
        PROVIDER_PREFIX: "",
        MATTER_PREFIX: "",
        APPOINTMENT_INTER: "",
        ACCOUNT_LOCKSTATE: "",
        NO_OF_PROVIDER: "",
        NOOF_ENCOUNTER_PERMONTH: "",
        NOOF_ENCOUNTER_PERYEAR: "",
        NOOF_MINUTE_PERMONTH: "",
        NOOF_MINUTE_PERYEAR: "",
        ISPROVIDER_EMAIL_CONFIGURATION: "",
        APPOINTMENT_EMAIL_CONFIGURATION: "",
        ISCUSTOMER_EMAIL_CONFIGURATION: "",
    });

    const [stateList, SetStateList] = useState([]);

    const [getTenantId, setGetTenantId] = useState(urlTenantID());

    const [error, setError] = useState({
        CUSTOMER_PREFIX: "",
        PROVIDER_PREFIX: "",
        MATTER_PREFIX: "",
        APPOINTMENT_INTER: "",
        NO_OF_PROVIDER: "",
        ACCOUNT_LOCKSTATE: "",
        NOOF_ENCOUNTER_PERMONTH: "",
        NOOF_ENCOUNTER_PERYEAR: "",
        NOOF_MINUTE_PERMONTH: "",
        NOOF_MINUTE_PERYEAR: "",
    });

    const [regex, setRegex] = useState({
        prefix: /^\d{2}-\d{4}$|^\d-\d{2}$|^.*-.*$/,
        provider: /[0-9]/,
    })

    // grabs the id of the url and loads the corresponding data
    useEffect(() => {
        const id = match.params.id;
        if (id !== undefined || null || "") {
            let spUser = data.find((item) => item.id === Number(id));
            setUser(spUser);
        } else {
            setUser(data[0]);
        }
    }, [match.params.id, data]);

    // function to toggle sidebar
    const toggle = () => {
        setSidebar(!sideBar);
    };

    // delete a note
    const deleteNote = (id) => {
        let defaultNote = noteData;
        defaultNote = defaultNote.filter((item) => item.id !== id);
        setNoteData(defaultNote);
    };

    const submitNote = () => {
        let submitData = {
            id: Math.random(),
            text: addNoteText,
            date: `${monthNames[todaysDate.getMonth()]} ${todaysDate.getDate()}, ${todaysDate.getFullYear()}`,
            time: `${currentTime()}`,
            company: "Softnio",
        };
        setNoteData([...noteData, submitData]);
        setAddNoteModal(false);
        setAddNoteText("");
    };

    const handleChange = (eve) => {
        const { name, value } = eve?.target;
        setVal({ ...val, [name]: value });
    }

    const handleChecked = (eve) => {
        const { name, checked } = eve?.target;
        setVal({ ...val, [name]: checked });
    }

    const getSmsSettings = async () => {
        try {
            let response = await Api?.GetStateByCountryId(239);
            if (response?.data?.statusCode === 200) {
                SetStateList(response?.data?.data);
            }
        } catch (error) {
            Swal?.fire({
                icon: "error",
                title: "Something Went Wrong",
            })
        }
        let data = JSON?.stringify([
            { tenantId: getTenantId, keyStr: "CUSTOMER_PREFIX", },
            { tenantId: getTenantId, keyStr: "PROVIDER_PREFIX", },
            { tenantId: getTenantId, keyStr: "MATTER_PREFIX", },
            { tenantId: getTenantId, keyStr: "APPOINTMENT_INTER", },
            { tenantId: getTenantId, keyStr: "ACCOUNT_LOCKSTATE", },
            { tenantId: getTenantId, keyStr: "NO_OF_PROVIDER", },
            { tenantId: getTenantId, keyStr: "NOOF_ENCOUNTER_PERMONTH", },
            { tenantId: getTenantId, keyStr: "NOOF_ENCOUNTER_PERYEAR", },
            { tenantId: getTenantId, keyStr: "NOOF_MINUTE_PERMONTH", },
            { tenantId: getTenantId, keyStr: "NOOF_MINUTE_PERYEAR", },
            { tenantId: getTenantId, keyStr: "ISPROVIDER_EMAIL_CONFIGURATION", },
            { tenantId: getTenantId, keyStr: "APPOINTMENT_EMAIL_CONFIGURATION", },
            { tenantId: getTenantId, keyStr: "ISCUSTOMER_EMAIL_CONFIGURATION", },
        ])
        let response = await Api?.getSmtpSettings(data);
        let res = response?.data?.data;
        if (res !== null) {
            let datas = {};
            let prefers = {};
            res.forEach(curr => {
                datas[curr.keyStr] = curr.valueStr || "";
                prefers[curr.keyStr] = curr.tenantPrefId;
            });
            datas.ISPROVIDER_EMAIL_CONFIGURATION = datas.ISPROVIDER_EMAIL_CONFIGURATION === "true" ? true : false;
            datas.APPOINTMENT_EMAIL_CONFIGURATION = datas.APPOINTMENT_EMAIL_CONFIGURATION === "true" ? true : false;
            datas.ISCUSTOMER_EMAIL_CONFIGURATION = datas.ISCUSTOMER_EMAIL_CONFIGURATION === "true" ? true : false;
            let states = [];
            if (datas?.ACCOUNT_LOCKSTATE) {
                states = datas?.ACCOUNT_LOCKSTATE?.split(",")
            }
            let dataObj = {
                CUSTOMER_PREFIX: datas?.CUSTOMER_PREFIX || "",
                PROVIDER_PREFIX: datas?.PROVIDER_PREFIX || "",
                MATTER_PREFIX: datas?.MATTER_PREFIX || "",
                APPOINTMENT_INTER: datas?.APPOINTMENT_INTER || "",
                ACCOUNT_LOCKSTATE: states?.flatMap(item => item.split(',')),
                NO_OF_PROVIDER: datas?.NO_OF_PROVIDER || "",
                NOOF_ENCOUNTER_PERMONTH: datas?.NOOF_ENCOUNTER_PERMONTH || "",
                NOOF_ENCOUNTER_PERYEAR: datas?.NOOF_ENCOUNTER_PERYEAR || "",
                NOOF_MINUTE_PERMONTH: datas?.NOOF_MINUTE_PERMONTH || "",
                NOOF_MINUTE_PERYEAR: datas?.NOOF_MINUTE_PERYEAR || "",
                ISPROVIDER_EMAIL_CONFIGURATION: datas?.ISPROVIDER_EMAIL_CONFIGURATION ? datas?.ISPROVIDER_EMAIL_CONFIGURATION : false,
                APPOINTMENT_EMAIL_CONFIGURATION: datas?.APPOINTMENT_EMAIL_CONFIGURATION ? datas?.APPOINTMENT_EMAIL_CONFIGURATION : false,
                ISCUSTOMER_EMAIL_CONFIGURATION: datas?.ISCUSTOMER_EMAIL_CONFIGURATION ? datas?.ISCUSTOMER_EMAIL_CONFIGURATION : false,
            }
            setVal(dataObj);
            setPrefer(prefers)
        }
    }

    const areAllEmpty = () => {
        return Object.values(prefer).every(value => value === "");
    };

    const validateField = (fieldName, value, regex, errorMessage) => {
        if (Array.isArray(value)) {
            return value.length > 0 ? "" : errorMessage;
        } else {
            return regex.test(value) ? "" : errorMessage;
        }
    };

    const handleSubmit = async (eve) => {
        eve?.preventDefault();

        const { prefix, provider } = regex;
        let errors = cloneDeep(error);

   

        const fieldsToValidate = {
            CUSTOMER_PREFIX: { value: val.CUSTOMER_PREFIX, regex: prefix, errorMessage: "Enter valid Client Prefix." },
            PROVIDER_PREFIX: { value: val.PROVIDER_PREFIX, regex: prefix, errorMessage: "Enter valid Provider Prefix." },
            MATTER_PREFIX: { value: val.MATTER_PREFIX, regex: prefix, errorMessage: "Enter valid Case Prefix." },
            APPOINTMENT_INTER: { value: val.APPOINTMENT_INTER, regex: prefix, errorMessage: "Enter valid Appointment Prefix." },
            NO_OF_PROVIDER: { value: +val.NO_OF_PROVIDER, regex: provider, errorMessage: "Enter valid Number of Providers." },
            ACCOUNT_LOCKSTATE: { value: val.ACCOUNT_LOCKSTATE, errorMessage: "Select Atleast 1 Lock State", isArray: true },
            // NOOF_ENCOUNTER_PERMONTH: { value: +val.NOOF_ENCOUNTER_PERMONTH, regex: provider, errorMessage: "Enter valid Number of Encounter Per Month." },
            // NOOF_ENCOUNTER_PERYEAR: { value: +val.NOOF_ENCOUNTER_PERYEAR, regex: provider, errorMessage: "Enter valid Number of Encounter Per Year." },
            // NOOF_MINUTE_PERMONTH: { value: +val.NOOF_MINUTE_PERMONTH, regex: provider, errorMessage: "Enter valid Number of Minutes Per Month." },
            // NOOF_MINUTE_PERYEAR: { value: +val.NOOF_MINUTE_PERYEAR, regex: provider, errorMessage: "Enter valid Number of Minutes Per Year." },
        };

        Object.entries(fieldsToValidate).forEach(([key, { value, regex, errorMessage, isArray }]) => {
            errors[key] = validateField(key, value, regex, errorMessage);
        });

        let formValid = Object?.values(errors)?.every(ele => ele === "");
        if (formValid) {
            if (areAllEmpty()) {
                let data = JSON?.stringify([
                    {
                        tenantId: getTenantId,
                        keyStr: "CUSTOMER_PREFIX",
                        valueStr: val?.CUSTOMER_PREFIX,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "PROVIDER_PREFIX",
                        valueStr: val?.PROVIDER_PREFIX,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "MATTER_PREFIX",
                        valueStr: val?.MATTER_PREFIX,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "APPOINTMENT_INTER",
                        valueStr: val?.APPOINTMENT_INTER,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "ACCOUNT_LOCKSTATE",
                        valueStr: val?.ACCOUNT_LOCKSTATE?.join(","),
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        keyStr: "NO_OF_PROVIDER",
                        valueStr: val?.NO_OF_PROVIDER,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                ]);
                try {
                    let response = await Api?.insertSmtpSettings(data);
                    Swal?.fire({
                        icon: response?.data?.statusCode === 200 ? "success" : "error",
                        title: response?.data?.statusCode === 200 ? "Setting Updated Successfully" : "Something Went Wrong"
                    });
                    getSmsSettings();
                } catch (error) {
                    Swal?.fire({
                        icon: "error",
                        title: "Something Went Wrong"
                    });
                }
            } else {
                let data = JSON?.stringify([
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.CUSTOMER_PREFIX,
                        keyStr: "CUSTOMER_PREFIX",
                        valueStr: val?.CUSTOMER_PREFIX,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.PROVIDER_PREFIX,
                        keyStr: "PROVIDER_PREFIX",
                        valueStr: val?.PROVIDER_PREFIX,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.MATTER_PREFIX,
                        keyStr: "MATTER_PREFIX",
                        valueStr: val?.MATTER_PREFIX,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.APPOINTMENT_INTER,
                        keyStr: "APPOINTMENT_INTER",
                        valueStr: val?.APPOINTMENT_INTER,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.ACCOUNT_LOCKSTATE,
                        keyStr: "ACCOUNT_LOCKSTATE",
                        valueStr: val?.ACCOUNT_LOCKSTATE?.join(",")?.replaceAll('"', ""),
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                    {
                        tenantId: getTenantId,
                        tenantPrefId: prefer?.NO_OF_PROVIDER,
                        keyStr: "NO_OF_PROVIDER",
                        valueStr: val?.NO_OF_PROVIDER,
                        createdOn: timeStamp(),
                        createdBy: formDataUsername(),
                        updatedOn: timeStamp(),
                        updatedBy: timeStamp(),
                    },
                ]);
                try {
                    let response = await Api?.insertSmtpSettings(data);
                    Swal?.fire({
                        icon: response?.data?.statusCode === 200 ? "success" : "error",
                        title: response?.data?.statusCode === 200 ? "Setting Updated Succesfully" : "Something Went Wrong"
                    });
                    getSmsSettings();
                } catch (error) {
                    Swal?.fire({
                        icon: "error",
                        title: "Something Went Wrong"
                    });
                }
            }
        }
        setError(errors);
    }

    useEffect(() => {
        getSmsSettings();
    }, []);
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    return (
        <React.Fragment>
            <Head title="User Details - Regular"></Head>
            {user && (
                <Content>
                    <TenantHeading heading={"Add Tenant Detail"} />
                    <TenantTab match={match} />
                    <Block>
                        <Card className="card-bordered">
                            <div className="card-aside-wrap" id="user-detail-block">
                                <div className="card-content">

                                    <div className="card-inner">
                                        <Block>
                                            <h4 className="mb-3">Settings</h4>
                                            <form onSubmit={handleSubmit}>
                                                <Row className="mb-3">
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="first-name">
                                                                Client Prefix
                                                            </Label>
                                                            <div>Customize Client ID by applying prefix. e.g. CLI-XXXXX </div>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" value={val?.CUSTOMER_PREFIX} name="CUSTOMER_PREFIX" onChange={handleChange} />
                                                                {error?.CUSTOMER_PREFIX && <span className="invalid">{error?.CUSTOMER_PREFIX}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                Provider Prefix
                                                            </Label>
                                                            <div>Customize Provider ID by applying prefix. e.g. PRV-XXXXX </div>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" value={val?.PROVIDER_PREFIX} name="PROVIDER_PREFIX" onChange={handleChange} />
                                                                {error?.PROVIDER_PREFIX && <span className="invalid">{error?.PROVIDER_PREFIX}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="first-name">
                                                                Case Prefix
                                                            </Label>
                                                            <div>Customize Case ID by applying prefix. e.g. CAS-XXXXX </div>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" value={val?.MATTER_PREFIX} name="MATTER_PREFIX" onChange={handleChange} />
                                                                {error?.MATTER_PREFIX && <span className="invalid">{error?.MATTER_PREFIX}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" htmlFor="middle-name">
                                                                Appointment Inter
                                                            </Label>
                                                            <div>Customize Appointment ID by applying prefix. e.g. APT-XXXXX </div>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" value={val?.APPOINTMENT_INTER} name="APPOINTMENT_INTER" onChange={handleChange} />
                                                                {error?.APPOINTMENT_INTER && <span className="invalid">{error?.APPOINTMENT_INTER}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" >
                                                                Number of Provider
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <input className="form-control bg-blue-dim" type="text" value={val?.NO_OF_PROVIDER} name="NO_OF_PROVIDER" onChange={handleChange} />
                                                                {error?.NO_OF_PROVIDER && <span className="invalid">{error?.NO_OF_PROVIDER}</span>}
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md="6">
                                                        <div className="form-group">
                                                            <Label className="form-label" >
                                                                Lock State
                                                            </Label>
                                                            <div className="form-control-wrap">
                                                                <div className="form-control-select">
                                                                    <Select
                                                                        name="ACCOUNT_LOCKSTATE"
                                                                        className="form-control bg-blue-dim p-0 settings_multiple_name"
                                                                        multiple
                                                                        value={val.ACCOUNT_LOCKSTATE}
                                                                        onChange={handleChange}
                                                                        MenuProps={MenuProps}
                                                                    >
                                                                        {stateList?.map((ele, ind) => (
                                                                            <MenuItem
                                                                                key={ind}
                                                                                value={ele?.stateName}
                                                                            >
                                                                                {ele?.stateName}
                                                                            </MenuItem>
                                                                        ))}
                                                                    </Select>
                                                                    {error?.ACCOUNT_LOCKSTATE && <span className="invalid">{error?.ACCOUNT_LOCKSTATE}</span>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <div className="justify-end">
                                                    <Button color="primary" className="me-3" type="submit">Save</Button>
                                                </div>
                                            </form>
                                        </Block>
                                    </div>
                                </div>
                            </div>
                        </Card>
                    </Block>
                </Content>
            )}
        </React.Fragment>
    );
};
export default Settings;
